/**
 * AEB设备配置弹窗
 */
import React, { useEffect, useState } from 'react';
import { Modal, Form, InputNumber, Button, message, Space } from 'antd';
import { getDeviceAebConfigRequest, editDeviceAebConfigRequest } from '@/service/parameterConfiguration';
import { marginBottom } from 'html2canvas/dist/types/css/property-descriptors/margin';

interface AebDeviceConfigModalProps {
  data: any; // 设备数据
  closeModal: () => void; // 关闭弹窗的方法
}

interface AebConfigFormData {
  aebSwitch: number;
  volume: number;
}

const AebDeviceConfigModal = (props: AebDeviceConfigModalProps) => {
  const { data, closeModal } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  // 获取设备AEB配置
  const getAebConfig = async () => {
    setLoading(true);
    try {
      const res = await getDeviceAebConfigRequest({ sn: data.sn })||{};
      const resData = res?.data?.data ||{}
      // if (resData.success && response.data) {
        form.setFieldsValue({
          aebSwitch: resData.aebSwitch || 0,
          volume: resData.volume || 0,
        });
      // }
    } catch (error) {
      message.error('获取设备配置失败');
    } finally {
      setLoading(false);
    }
  };

  // 保存AEB配置
  const onSave = async () => {
    try {
      const values = await form.validateFields();
      setSaveLoading(true);

      const requestData = {
        aebSwitch: values.aebSwitch || 0,
        volume: values.volume || 0,
        reverse: 0 // 预留位，默认为0
      };

      await editDeviceAebConfigRequest(requestData, data.sn);
      message.success('保存成功');
      closeModal();
    } catch (error) {
      if ((error as any)?.errorFields) {
        message.error('请检查表单输入');
      } else {
        message.error('保存失败');
      }
    } finally {
      setSaveLoading(false);
    }
  };

  useEffect(() => {
    if (data?.sn) {
      getAebConfig();
    }
  }, [data?.sn]);

  return (
    <Modal
      title="AEB设备配置"
      open={true}
      onCancel={closeModal}
      width={520}
      footer={
        <Space>
          <Button onClick={closeModal}>取消</Button>
          <Button type="primary" loading={saveLoading} onClick={onSave}>
            保存
          </Button>
        </Space>
      }
    >
      <Form
        form={form}
        layout="horizontal"
       
        wrapperCol={{ span: 18 }}
        initialValues={{
          aebSwitch: 0,
          volume: 0,
        }}
      >
        <Form.Item
          label="设备SN"
        
        >
          <span>{data?.sn}</span>
        </Form.Item>

        <Form.Item
          label="AEB开关"
          name="aebSwitch"
          rules={[{ required: true, message: '请输入AEB开关状态' }]}
        >
          <InputNumber
            min={0}
            max={3}
            precision={0}
            style={{ width: '100%' }}
          />
        </Form.Item>
        <p style={{marginBottom:"20px", marginTop:"-12px",color:"#999"}}> 0：自启模式1：常开模式2：常关模式3：记忆模式</p>

        <Form.Item
          label="设备音量"
          name="volume"
          rules={[{ required: true, message: '请输入设备音量' }]}
        >
          <InputNumber
            min={0}
            precision={0}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Form>

      {loading && (
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          加载中...
        </div>
      )}
    </Modal>
  );
};

export default AebDeviceConfigModal;